module.exports = __webpack_public_path__ + "static/media/rotate-icon.86b1b677.svg";